export const QUERY_CONSTANTS = {
  GET_ALL_SAVED_PLACES: "GET_ALL_SAVED_PLACES",
  GET_GYM_BY_ID: "GET_GYM_BY_ID",
  GET_ALL_APPROVED_GYMS: "GET_ALL_APPROVED_GYMS",
  GET_ALL_COUNTRIES: "GET_ALL_COUNTRIES",
  GET_CONTACT_INFORMATION: "GET_CONTACT_INFORMATION",
  GET_LOYALTY_POINT_BALANCE: "GET_LOYALTY_POINT_BALANCE",
  GET_LOYALTY_EXCHANGES: "GET_LOYALTY_EXCHANGES",
  GET_LOYALTY_HISTORY: "GET_LOYALTY_HISTORY",
  GET_ALL_SUBSCRIPTIONS: "GET_ALL_SUBSCRIPTIONS",
  GET_ALL_ADDONS: "GET_ALL_ADDONS",
  GET_USER_SUBSCRIPTION: "GET_USER_SUBSCRIPTION",
  GET_ALL_INVOICES: "GET_ALL_INVOICES",
  GET_CLASS_EVENTS_BY_DAY_AND_GYM: "GET_CLASS_EVENTS_BY_DAY_AND_GYM",
  GET_SETTINGS: "GET_SETTINGS",

  GET_TIME_RANGES_FOR_CLASSES: "getTimeRangesForClasses",
  GET_UPCOMING_CLASS_EVENTS_RESERVATIONS: "getUpcomingClassEventsReservations",
  GET_ATTENDED_CLASS_EVENTS_RESERVATIONS: "getAttendedClassEventsReservations",
  GET_SERVICE_AVAILABILITY: "getServiceAvailability",
  GET_REVIEW_AVAILABILITY: "getReviewAvailability",
  GET_CLASS_EVENT_RESERVATION_BY_ID: "getClassEventReservationById",
  GET_ALL_REVIEWS: "getAllReviews",
  GET_CLASS_EVENTS_BY_DATE_AND_GYM_ID: "getClassEventsByDateAndGymId",
  GET_OPEN_GYMS_BY_DATE_AND_GYM_ID: "getOpenGymsByDateAndGymId",
  NOTIFICATION_FOR_COMING_SOON_GYM: "notificationForComingSoonGym",
  GET_ALL_CLASS_CATEGORIES: "getAllClassCategories",
  GET_CLASS_EVENTS_BY_GYM_WITH_FILTERS: "getClassEventsByGymWithFilters",
  GET_RECENT_CHARGES: "getRecentCharges",
  GET_STRIPE_PUBLIC_KEY: "GET_STRIPE_PUBLIC_KEY",
  GET_STRIPE_PAYMENT_METHODS: "GET_STRIPE_PAYMENT_METHODS",
  GET_USER_SUBSCRIPTION_CANCELLATION_REASON_KEYS: "GET_USER_SUBSCRIPTION_CANCELLATION_REASON_KEYS",
};
